import { useEffect, useState } from "react";

const useEditorPermission = ({ permissions, pengecekanData, headerData }) => {
  const [permittedToEdit, setPermittedToEdit] = useState(false);

  useEffect(() => {
    updatePermittedToEdit();
  }, [permissions, pengecekanData]);

  const updatePermittedToEdit = () => {
    // authorize to permit edit
    let _permittedToEdit = false;

    if (
      permissions &&
      (permissions.includes("view it") ||
        permissions.includes("view kabag-keamanan") ||
        permissions.includes("view keamanan"))
    ) {
      _permittedToEdit = true;
    }

    // all the signatures are done: nothing can be changed anymore
    if (
      headerData &&
      headerData.verif_diteliti_id &&
      headerData.verif_diteliti_id > 0 &&
      headerData.verif_diketahui_id &&
      headerData.verif_diketahui_id > 0 &&
      headerData.verif_dibuat_id &&
      headerData.verif_dibuat_id > 0
    ) {
      _permittedToEdit = false;
    }

    setPermittedToEdit(_permittedToEdit);
  };

  return { permittedToEdit };
};

export default useEditorPermission;
